/**
 * dir-w | backOffice
 * Application Header Component, contains `menus`, `profile`, `signOut`
 *
 * Last update : January 10, 2024 | @rizkiprasetya
 */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription, take } from 'rxjs';
import { Configuration } from '../../config/configuration';
import { IBaseRoleMenus } from '../../interfaces/role-menu.interface';
import { Auth } from '../../models/auth.model';
import { MenuService } from '../../services/menu.service';
import { AuthService } from '../../services/auth.service';
import { IHttpResponse } from '../../interfaces/http.interface';
import { StatusBarService } from '../../services/status-bar.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.css',
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  protected isLoading: boolean = false;
  protected errorText: string = '';
  protected configuration = Configuration;

  protected profileLogo = `/assets/profile/${Configuration.Profile}/images/logo.png`;
  protected profileLogoAlt = Configuration.Profile;
  protected roleMenus: IBaseRoleMenus[] = [];
  protected navSubject: Subscription;
  @Input() authUser: Auth | null = null;

  constructor(
    private _menuService: MenuService,
    private _authService: AuthService
  ) {
    this.navSubject = this._menuService.getUpdate().subscribe((message) => {
      this.fetchNavigations();
    });
  }

  ngOnDestroy(): void {
    this.navSubject.unsubscribe();
  }

  ngOnInit(): void {
    this.fetchNavigations();
  }

  /**
   * Fetch application menu navigations
   */
  fetchNavigations(): void {
    if (!this.authUser) return;

    // show the loading process
    this.isLoading = true;

    let lObservable: Observable<IHttpResponse>;
    lObservable = this._authService.menus();
    lObservable.pipe(take(1)).subscribe({
      next: (v) => {
        // console.log(v);

        this.roleMenus = v.authMenus!;

        // hide the loading process
        this.isLoading = false;
      },
      error: (e) => {
        // not using page properties cause it's a little bit different
        this.errorText = `<li class="text-danger small">${e.status} - ${e.statusText}. Loading menus failed</li>`;

        // hide the loading process
        this.isLoading = false;
      },
    });
  }
}
